export default __webpack_public_path__ + "static/media/Resume.41d6a8c0.pdf";